import React, { useState, useEffect, useRef } from 'react';
import { stopBackgroundScrolling, getFromSessionStorage, numberWithCommas, setInSessionStorage } from '../../../common/utils/app.utils';
import {
  MODULE_ID,
  serviceOptions,
  contractOptions,
  LEAD_STATUS,
  ROUTER_LISTS,
  LEAD_STATUS_MSG,
  ATTRIBUTE_TEXT,
  serviceHardwareOptions,
  DEDICATED_FEASIBILITY_RESPONSE,
  AVAILABLE_BANDWIDTH,
  PRODUCT_LIST,
  planListAboveText,
  planListAboveTextAfterDOA,
  CAPEX_MEDIA_TYPE
} from '../../../home/common/constants/constants';
import { DEDICATED_COMMON_PARAMS, MOENGAGE_ANALYTICS_EVENT, PRODUCT_NAME, PRODUCT_TYPE } from '../../../common/constants/app.constants';
import '../common/common.scss';
import './plan.scss';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Button from 'b2b-ui-components-lib/lib/components/button';
import ipAttribute from '../images/ip-attribute.svg';
import services from '../images/services.svg';
import wireless from '../images/wireless.svg';
import ribbonBadge from '../images/ribbon-badge.svg';
import helplineIcon from '../images/helpline-icon.svg';
import StripComponent from '../stripComponent/stripComponent';
import 'react-multi-carousel/lib/styles.css';
import MainLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
import {
  faOnDedicatedContractPeriodOKClick,
  faOnDedicatedSelectPlanClick,
  faOnDedicatedContractPeriodLoad,
  faOnDedicatedPlanConfiguration,
  faOnDedicatedKamPlanConfiguration,
  faOnDedicatedChangeRouterClick
} from '../../../dedicated/services/analytics.service';
import Slider from 'react-slick';
import ServicesPopup from '../servicesPopup/servicesPopup';
import OrderSummary from '../Ordersummary/OrderSummary';
import RouterPopup from '../RouterPopup/RouterPopup';
import NeedAssistant from '../need-assistant/need-assistant';
import { trackMOEEvent } from '../../../common/services/moengage.service';

import BaseCarousel from 'b2b-ui-components-lib/lib/components/baseCarousel';
import { carouselDefaultConfig } from './planCarousel.constants';
import PlanConfigrationModal from './planConfigrationModal';
import CustomerMessageCard from '../customerMessageCard/customerMessageCard';
import PlanNegotiationComponet from '../planNegotiationComponent/planNegotiationComponent';
import PlanConfigurationForMPLS from './planConfigurationForMPLS';
import ContractSelectModal from './contract-select-popup';
import { getDefaultValue } from './formControl';
import { prepareSpecModel, setMediaOptions, splittedBwValue, getSelectedMedia } from './plan.service';
import ChangePlanModal from './change-plan-modal';

BaseCarousel.defaultProps = {
  ...carouselDefaultConfig,
  carouselContainerClass: ''
};
const DedicatedPlanPage = ({
  plans,
  servicetype,
  setservicetype,
  setactiveStep,
  kamDetails,
  fetchLead,
  leadDetails,
  leadStatus,
  getLeadPlan,
  paramsValue,
  setleadStatus,
  pnqLeadData,
  getKamLeadData,
  submitLead,
  setAPIFetechingState,
  commercialAttribute,
  setCommercialAttributes,
  dualLastMile,
  feasibilityData,
  selectedPrimaryMedia,
  setSelectedPrimaryMedia,
  maxBandwidth = '',
  itemCode,
  setItemCode,
  rateCardIdList,
  setRateCardIdList,
  selectedRateCardId,
  setSelectedRateCardId
}) => {
  const childRef = useRef();
  const settings = {
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    infinite: false,
    initialSlide: 3,
    afterChange: (previous, current) => {
      afterSlideCallback(previous, current);
    }
  };

  const [primaryMediaOptions, setPrimaryMediaOptions] = useState([]);

  const setRouterSpecs = (plans, leadData) => {
    let slicePlan = plans;
    let modelListObj = {};
    let makeListObj = {};
    let selectedRouterObj = {};
    let checkCommercialHardWare = false;
    let routerListData = getFromSessionStorage(MODULE_ID, ROUTER_LISTS);
    slicePlan &&
      slicePlan.length > 0 &&
      slicePlan.map((planData, index) => {
        let routeSpecs = planData && planData.routerSpecs;
        let modelList = {};
        if ((routeSpecs && routeSpecs.length > 0) || (routerListData && Object.keys(routerListData).length > 0)) {
          if (routerListData && Object.keys(routerListData).length > 0) {
            let routerListDataKeys = Object.keys(routerListData);
            let matchedPlanSpeed = routerListDataKeys.find((routerListDataKey) => routerListDataKey == planData.speed);
            modelList = routerListData[matchedPlanSpeed] && routerListData[matchedPlanSpeed].router;
            setPlanSpecificRouter(modelList);
            let lineItems = leadData && leadData.lineItems[0];
            let getMake = lineItems && lineItems.plan && lineItems.plan.specs && lineItems.plan.specs.find((specs) => specs.name == 'cpe');
            let getModel =
              lineItems &&
              lineItems.plan &&
              lineItems.plan.site.length > 0 &&
              lineItems.plan.site[0] &&
              lineItems.plan.site[0].siteSpecs &&
              lineItems.plan.site[0].siteSpecs.find((specs) => specs.name == 'cpeSpecification');
            if (lineItems && lineItems.plan && planData.speed === lineItems.plan.bandwidth && getMake && getMake.value && getModel && getModel.value) {
              let routerSpecsData = {};
              routerSpecsData.make = getMake && getMake.value ? getMake.value : '';
              routerSpecsData.model = getModel && getModel.value ? getModel.value : '';
              checkCommercialHardWare = getModel && getModel.commercial ? true : false;
              routerSpecsData.cost = '';
              routerSpecsData.commercial = checkCommercialHardWare ? true : false;
              routerSpecsData.linkType = 'PRIMARY';
              selectedRouterObj[planData.id] = routerSpecsData;
              setHardwareType(checkCommercialHardWare ? serviceHardwareOptions[1] : serviceHardwareOptions[0]);
            } else {
              let firstObj = {};
              for (let key in modelList) {
                if (modelList.hasOwnProperty(key)) {
                  // if(key==='Huawei'){
                  firstObj.key = key;
                  firstObj.content = modelList[key];
                  break;
                  // }
                }
              }
              if (firstObj && firstObj.content && firstObj.content.length > 0) {
                firstObj.content[0].make = firstObj.key;
                selectedRouterObj[planData.id] = firstObj.content[0];
              }
            }
          } else if (routeSpecs && routeSpecs.length > 0) {
            modelList = routeSpecs
              .filter((item) => !item.nonStandard)
              ?.reduce((r, a) => {
                r[a.make] = [...(r[a.make] || []), a];
                return r;
              }, {});
            if (getLeadPlan && getLeadPlan.routerSpecs && getLeadPlan.routerSpecs.length > 0 && planData.speed === getLeadPlan.speed) {
              selectedRouterObj[planData.id] = getLeadPlan.routerSpecs[0];
              checkCommercialHardWare = getLeadPlan.routerSpecs[0] && getLeadPlan.routerSpecs[0].commercial ? true : false;
              setHardwareType(checkCommercialHardWare ? serviceHardwareOptions[1] : serviceHardwareOptions[0]);
            } else {
              selectedRouterObj[planData.id] = routeSpecs.filter((item) => !item.nonStandard)?.[0];
            }
          }
          if (modelList && Object.keys(modelList).length > 0) {
            modelListObj[planData.id] = modelList;
            makeListObj[planData.id] = Object.keys(modelList);
            if (checkCommercialHardWare && commercialAttribute && commercialAttribute.cpeSpecification && commercialAttribute.cpe) {
              setRouterSpecsModel(commercialAttribute && commercialAttribute.cpeSpecification);
              setRouterSpecsMake(commercialAttribute && commercialAttribute.cpe);
            } else {
              setRouterSpecsModel(modelListObj);
              setRouterSpecsMake(makeListObj);
            }
            setSelectedRouter({ ...selectedRouterObj });
            let getFeasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
            if (
              !getLeadPlan &&
              getFeasibilityResponse &&
              planData &&
              getFeasibilityResponse.requestedBandwidth === parseInt(planData.speed) &&
              paramsValue &&
              paramsValue.user !== 'KAM'
            ) {
              setTimeout(() => {
                onSelect(planData, index, selectedRouterObj);
              }, 1000);
            }
          }
        }
        if (getLeadPlan && planData.speed === getLeadPlan.speed) {
          let activePlan = { activeId: planData.id, planSpeed: planData.speed };
          let activePlanData = getLeadPlan;
          activePlanData.id = planData.id;
          setactiveId(activePlan);
          setselectedPlan({ ...activePlanData });
          if (selectedcontractOption && getLeadPlan.planPeriod && selectedcontractOption.id) {
            let planPeriodObj = {};
            let planPeriodvalue = parseInt(getLeadPlan.planPeriod) / 12;
            planPeriodObj.id = planPeriodvalue.toString();
            planPeriodObj.value = planPeriodvalue;
            let planPeriodText = planPeriodvalue === 1 ? ' Year' : ' Years';
            planPeriodObj.displayName = planPeriodvalue + planPeriodText;
            onContractChange(planPeriodObj);
          }
        }
      });
    if (paramsValue && paramsValue.user == 'KAM') {
      setplansArray(plans);
    }
  };
  const changeetRouterValue = (value, routerIndex) => {
    if (routerIndex >= 0) {
      selectedRouter[routerIndex] = value;
    } else {
      setSelectedRouter(value);
    }
  };
  const changeRouter = (routerIndex) => {
    setRouterIndex(routerIndex);
    setShowRouterPopup(true);
    faOnDedicatedChangeRouterClick();
  };
  const closeRouterPopup = () => {
    stopBackgroundScrolling(false);
    setShowRouterPopup(false);
  };

  const updateCommercialAttrs = (plans, activeId, standardRoutersOnly = true) => {
    const selectedPlan = plans?.find((item) => item?.speed === activeId?.planSpeed) ?? null;
    const routerSpecs = selectedPlan?.routerSpecs ?? [];
    const nonStandardRoutersList = routerSpecs?.filter((item) => item?.nonStandard) ?? [];
    const standardRoutersList = routerSpecs?.filter((item) => !item?.nonStandard) ?? [];
    let selectedRouterType = nonStandardRoutersList;

    if (standardRoutersOnly) {
      selectedRouterType = standardRoutersList;
    }

    const makeList = [];
    const modelList = {};

    selectedRouterType?.forEach((item) => {
      if (item?.make) {
        makeList.push(item.make);
        modelList[item.make] = [];
      }
    });

    Object.entries(modelList).map(([key, value]) => {
      selectedRouterType?.forEach((item) => {
        if (item['make'] === key && item['model']) {
          value.push(item['model']);
        }
      });
    });

    setCommercialAttributes((commercialAttribute) => ({
      ...commercialAttribute,
      cpe: [...new Set(makeList)],
      cpeSpecification: modelList
    }));
  };

  useEffect(() => {
    trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.AUTH_PLAN_PAGE_VISIT);
    setPlanSlider();

    if (plans?.length > 0 && activeId?.planSpeed) {
      updateCommercialAttrs(plans, activeId, false);
    }
  }, [plans, activeId?.planSpeed]);

  const getSelectedPlanIndex = () => {
    let selectedPlanIndex = '';
    if (getLeadPlan && getLeadPlan.speed) {
      selectedPlanIndex = plansArray && plansArray.length > 0 && plansArray.findIndex((planValues) => planValues.speed === getLeadPlan.speed);
      if ((selectedPlanIndex === -1 || !selectedPlanIndex) && selectedPlanIndex !== 0) {
        selectedPlanIndex = plans && plans.length < 3 ? 0 : currentSpeedIndex;
      }
    } else if (pnqLeadData && pnqLeadData.length > 0) {
      let lineItemsValue = pnqLeadData[0].lineItems && pnqLeadData[0].lineItems.length > 0 && pnqLeadData[0].lineItems[0];
      let speed = lineItemsValue && lineItemsValue.plan && lineItemsValue.plan.bandwidth;
      let getPlanIndex = plansArray && plansArray.length > 0 && plansArray.findIndex((planValues) => planValues.speed === speed);
      if ((getPlanIndex === -1 || !getPlanIndex) && getPlanIndex !== 0) {
        getPlanIndex = plans && plans.length < 3 ? 0 : currentSpeedIndex;
      }
      selectedPlanIndex = getPlanIndex;
    }
    return selectedPlanIndex ? selectedPlanIndex : 0;
  };
  const checkSelectedPlan = (setShowAllPlanStatus) => {
    let checkStatus = false;
    let selectedPlanIndex = getSelectedPlanIndex();
    let getShowAllPlanStatus = setShowAllPlanStatus ? setShowAllPlanStatus : showAllPlan;
    if (
      !getShowAllPlanStatus &&
      selectedPlanIndex !== -1 &&
      leadStatus &&
      (leadStatus.toUpperCase() === LEAD_STATUS.FEASIBILITY_PENDING ||
        leadStatus.toUpperCase() === LEAD_STATUS.PNQ_IN_PROGRESS ||
        leadStatus.toUpperCase() === LEAD_STATUS.PNQ_COMPLETED ||
        (paramsValue && paramsValue.user === 'KAM' && leadStatus !== 'REQUIRED_PRICE_NEGOTIATION'))
    ) {
      checkStatus = true;
    }
    return checkStatus;
  };
  const setSliderIndex = (plans, checkValue) => {
    let getIndex = '';
    checkValue = typeof checkValue === 'number' ? checkValue + ' Mbps' : checkValue;
    getIndex = plans && plans.length > 0 && plans.findIndex((planValues) => planValues.speed === checkValue);
    if (getIndex === -1 || getIndex === false) {
      getIndex = plans && plans.length < 3 ? 0 : currentSpeedIndex;
    }
    return getIndex;
  };

  const setPlanSlider = (value) => {
    let setShowAllplanStatus = value ? true : false;
    if (plans.length) {
      let speedArr = plans.map((plan, index) => +(plan.speed.split(' ')[1] == 'Gbps' ? plan.speed.split(' ')[0] * 1024 : plan.speed.split(' ')[0]));
      setspeedArray(speedArr);
      let slicePlan = [];
      let selectedPlanIndex = '';
      let userRemarks = leadDetails && leadDetails.customerRemarks;
      if (userRemarks) {
        setremarks(userRemarks);
      }
      let getFeasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
      if (getLeadPlan && getLeadPlan.speed) {
        selectedPlanIndex = setSliderIndex(plans, getLeadPlan.speed);
        slicePlan = plans.slice(selectedPlanIndex, selectedPlanIndex + 4);
        setSelectedIpAttributes(getLeadPlan && getLeadPlan.specs);
        setcurrentSpeedIndex(selectedPlanIndex);
      } else if (pnqLeadData && pnqLeadData.length > 0) {
        let lineItemsValue = pnqLeadData[0].lineItems && pnqLeadData[0].lineItems.length > 0 && pnqLeadData[0].lineItems[0];
        let speed = lineItemsValue && lineItemsValue.plan && lineItemsValue.plan.bandwidth;
        selectedPlanIndex = setSliderIndex(plans, speed);
        slicePlan = plans.slice(selectedPlanIndex, selectedPlanIndex + 4);
        setcurrentSpeedIndex(selectedPlanIndex);
        let siteSpecs =
          lineItemsValue &&
          lineItemsValue.plan &&
          lineItemsValue.plan.site &&
          lineItemsValue.plan.site.length > 0 &&
          lineItemsValue.plan.site[0] &&
          lineItemsValue.plan.site[0].siteSpecs;
        let getIpAttributeIndex = siteSpecs && siteSpecs.length > 0 && siteSpecs.findIndex((siteSpec) => siteSpec.name === 'ipVersion');
        if (getIpAttributeIndex !== -1) {
          setSelectedIpAttributes(siteSpecs);
        }
      } else if (getFeasibilityResponse && getFeasibilityResponse.requestedBandwidth) {
        let requestedBandwidth = getFeasibilityResponse.requestedBandwidth;
        selectedPlanIndex = setSliderIndex(plans, requestedBandwidth);
        let getSelectedPlanIndexValue = selectedPlanIndex;
        let moveIndex = getSelectedPlanIndexValue + 4;
        if (plans && plans.length <= moveIndex) {
          getSelectedPlanIndexValue = plans.length > 5 ? plans.length - 4 : plans.length - getSelectedPlanIndexValue;
        }
        getSelectedPlanIndexValue = plans && plans.length <= 4 ? 0 : getSelectedPlanIndexValue;
        slicePlan = plans.slice(getSelectedPlanIndexValue, getSelectedPlanIndexValue + 4);
        setcurrentSpeedIndex(getSelectedPlanIndexValue);
      } else {
        let getCurrentSpeedIndex = plans && plans.length < 3 ? 0 : currentSpeedIndex;
        slicePlan = plans.slice(getCurrentSpeedIndex, getCurrentSpeedIndex + 4);
      }
      setTimeout(() => {
        childRef.current.slickGoTo(selectedPlanIndex);
      }, 300);

      if (paramsValue && paramsValue.user == 'KAM') {
        getKamplan(slicePlan);
      } else {
        setRouterSpecs(slicePlan);
      }
      if (checkSelectedPlan(setShowAllplanStatus, selectedPlanIndex) && paramsValue && paramsValue.user !== 'KAM') {
        let modifyPlan = [];
        modifyPlan[0] = slicePlan[0];
        setplansArray(modifyPlan);
      } else {
        setplansArray(slicePlan);
      }
      if (selectedPlan) {
        let selectedP = plans.filter((plan) => activeId && activeId.planSpeed === plan.speed);
        const newPlan = { ...selectedP[0] };
        newPlan.specs = selectedPlan.specs ? selectedPlan.specs : [];
        newPlan.service = selectedPlan.service ? selectedPlan.service : 'MANAGED';
        setselectedPlan(newPlan);
      }
      setPlanConfigrationOpen(false);
    }
  };
  const setShowAllPlanList = (value) => {
    setShowAllPlan(value ? true : false);
    setPlanSlider(value);
  };
  const getKamplan = (slicePlan) => {
    let isLeadData = pnqLeadData && pnqLeadData.length;
    let leadData = pnqLeadData && pnqLeadData.length && pnqLeadData[0];
    let leadStats = leadData && leadData.leadStatus;
    let plan = leadData && leadData.lineItems && leadData.lineItems.length && leadData.lineItems[0].plan;
    setleadStatus(leadStats);
    if (leadStats == LEAD_STATUS.LEAD_SUBMITTED) {
      setdisable(true);
    } else if (leadStats == 'PRICING_APPROVAL_REQUEST_SENT' || leadStats == 'PRICING_DOA_REJECTED' || leadStats == 'PRICING_DOA_APPROVED' || leadStats == 'LEAD_CANCELLED') {
    }
    if (isLeadData) {
      setpnqPayload(leadData);
      setdoaStatus(leadData && leadData.doaStatus);
      setdoaId(leadData && leadData.doaId);
      if (selectedcontractOption && leadData && leadData.contractPeriod) {
        let planPeriodObj = {};
        let planPeriodvalue = parseInt(leadData.contractPeriod) / 12;
        planPeriodObj.id = planPeriodvalue.toString();
        planPeriodObj.value = planPeriodvalue;
        planPeriodObj.checked = true;
        let planPeriodText = planPeriodvalue === 1 ? ' Year' : ' Years';
        planPeriodObj.displayName = planPeriodvalue + planPeriodText;
        onContractChange(planPeriodObj);
      }
      let userRemarks = leadData && leadData.remarks && leadData.remarks.length > 0 && leadData.remarks.find((remark) => remark.userType === 'CUSTOMER');
      if (userRemarks && userRemarks.remarks) {
        setremarks(userRemarks);
      }
      if (leadData && leadData.lineItems && leadData.lineItems.length) {
        let planPrice = leadData && leadData.lineItems[0].plan.price;
        let matchedPlan = slicePlan.find((plan) => plan.speed == pnqLeadData[0].lineItems[0].plan.bandwidth);
        let activePlan = {
          activeId: matchedPlan && matchedPlan.id,
          planSpeed: matchedPlan && matchedPlan.speed
        };
        setactiveId(activePlan);
        let floorPrice = matchedPlan && matchedPlan.floorPrice;
        let selectedPlanValue = {
          speed: pnqLeadData[0].lineItems[0].plan.bandwidth,
          service: pnqLeadData[0].lineItems[0].subProductName,
          price: {
            amount: planPrice.rental,
            otc: planPrice.oneTimeCharge,
            customPricePlan: planPrice.customPricePlan
          },
          floorPrice: floorPrice
        };
        let siteSpecs =
          pnqLeadData &&
          pnqLeadData.length &&
          pnqLeadData[0] &&
          pnqLeadData[0].lineItems &&
          pnqLeadData[0].lineItems.length > 0 &&
          pnqLeadData[0].lineItems[0].plan &&
          pnqLeadData[0].lineItems[0].plan.site &&
          pnqLeadData[0].lineItems[0].plan.site.length > 0 &&
          pnqLeadData[0].lineItems[0].plan.site[0].siteSpecs;
        selectedPlanValue.specs = siteSpecs;
        setselectedPlan(selectedPlanValue);
        setkamPlan(plan);
        setRouterSpecs(slicePlan, leadData);
      }
    }
  };
  useEffect(() => {
    if (selectedPlan) {
      setactiveStep('summary');
    } else {
      setactiveStep('');
    }
  }, [selectedPlan]);

  let [kamPlan, setkamPlan] = useState(null);
  let [selectedserviceOption, setselectedserviceOption] = useState(
    servicetype === 'MANAGED' ? serviceOptions[0] : servicetype === 'UNMANAGED' ? serviceOptions[1] : serviceOptions[2]
  );
  let [selectedcontractOption, setselectedcontractOption] = useState(contractOptions[0]);
  const [isLoading, setisLoading] = useState(false);
  let [plansArray, setplansArray] = useState([]);
  let [speedArray, setspeedArray] = useState([]);
  let [currentSpeedIndex, setcurrentSpeedIndex] = useState(3);
  const [contractPeriod, setcontractPeriod] = useState('1 Year');
  const [activeId, setactiveId] = useState(null);
  let [showPopup, setshowPopup] = useState(false);
  let [showmorePopup, setshowmorePopup] = useState(false);
  let [selectedPlan, setselectedPlan] = useState(null);
  let [routerSpecsMake, setRouterSpecsMake] = useState({});
  let [routerSpecsModel, setRouterSpecsModel] = useState({});
  let [selectedRouter, setSelectedRouter] = useState({});
  let [showRouterPopup, setShowRouterPopup] = useState(false);
  let [routerIndex, setRouterIndex] = useState(0);
  let [pnqPayload, setpnqPayload] = useState(null);
  let [doaStatus, setdoaStatus] = useState('');
  let [doaId, setdoaId] = useState('');
  let [remarks, setremarks] = useState('');
  let [disable, setdisable] = useState(false);
  let [selectedIpAttributes, setSelectedIpAttributes] = useState({});
  let [showManualFeasibilityMsg, setShowManualFeasibilityMsg] = useState(
    leadDetails &&
      leadDetails.feasibilityStatus &&
      leadDetails.feasibilityStatus.toUpperCase() === LEAD_STATUS.MANUAL_INTERVENTION_REQUIRED &&
      (leadStatus.toUpperCase() !== LEAD_STATUS.FEASIBILITY_PENDING || leadStatus.toUpperCase() !== LEAD_STATUS.PNQ_IN_PROGRESS)
      ? true
      : false
  );
  let [showAllPlan, setShowAllPlan] = useState(false);
  const [ipAttributeType, setIpAttributeType] = useState(false);
  const [planConfigrationOpen, setPlanConfigrationOpen] = useState('');
  let [selectedHardwareType, setHardwareType] = useState(
    selectedHardwareType && selectedHardwareType.value === 'NON_STANDARD' ? serviceHardwareOptions[1] : serviceHardwareOptions[0]
  );

  const [currentPlanIpAttribute, setCurrentPlanIpAttribute] = useState(null);
  const [showChangePlan, setShowChangePlan] = useState(false);
  const [changePlan, setChangePlan] = useState(null);
  const [planObject, setPlanIndex] = useState(null);
  const [planSpecificRouter, setPlanSpecificRouter] = useState([]);

  const filteredMediaOptions = (selectedPlanSpeed = '') => {
    const feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
    const isSiteManualFeasible = feasibilityData && feasibilityData.feasibilityStatus === 'MANUAL_INTERVENTION_REQUIRED';
    const isSitePendingThirdParty = feasibilityData && feasibilityData.feasibilityStatus === 'PENDING_FOR_THIRD_PARTY';
    const getSiteSpecs = () => {
      if (paramsValue && paramsValue.user === 'KAM') {
        const kamLineItemData = (pnqLeadData && Array.isArray(pnqLeadData) && pnqLeadData.length > 0 && pnqLeadData[0]) || null;
        const kamSiteDetails =
          (kamLineItemData &&
            Array.isArray(kamLineItemData.lineItems) &&
            kamLineItemData.lineItems.length > 0 &&
            kamLineItemData.lineItems[0] &&
            kamLineItemData.lineItems[0].plan &&
            Array.isArray(kamLineItemData.lineItems[0].plan.site) &&
            kamLineItemData.lineItems[0].plan.site.length > 0 &&
            kamLineItemData.lineItems[0].plan.site[0] &&
            kamLineItemData.lineItems[0].plan.site[0].siteSpecs &&
            Array.isArray(kamLineItemData.lineItems[0].plan.site[0].siteSpecs) &&
            kamLineItemData.lineItems[0].plan.site[0].siteSpecs.length > 0 &&
            kamLineItemData.lineItems[0].plan.site[0].siteSpecs) ||
          [];

        return kamSiteDetails;
      }

      const siteDetails =
        (leadDetails &&
          leadDetails.connectivityLineItems &&
          Array.isArray(leadDetails.connectivityLineItems) &&
          leadDetails.connectivityLineItems.length > 0 &&
          leadDetails.connectivityLineItems[0] &&
          leadDetails.connectivityLineItems[0].planDetail &&
          leadDetails.connectivityLineItems[0].planDetail.specs) ||
        [];

      return siteDetails;
    };

    const getSelectedBw = () => {
      if (paramsValue && paramsValue.user === 'KAM') {
        const kamLineItemData = (pnqLeadData && Array.isArray(pnqLeadData) && pnqLeadData.length > 0 && pnqLeadData[0]) || null;
        const kamSelectedBw =
          (kamLineItemData &&
            Array.isArray(kamLineItemData.lineItems) &&
            kamLineItemData.lineItems.length > 0 &&
            kamLineItemData.lineItems[0] &&
            kamLineItemData.lineItems[0].plan &&
            kamLineItemData.lineItems[0].plan.bandwidth) ||
          '';

        const [bwValue] = (kamSelectedBw && splittedBwValue(kamSelectedBw)) || '';

        return bwValue || '';
      }

      const customerSelectedBw =
        (leadDetails &&
          leadDetails.connectivityLineItems &&
          Array.isArray(leadDetails.connectivityLineItems) &&
          leadDetails.connectivityLineItems.length > 0 &&
          leadDetails.connectivityLineItems[0] &&
          leadDetails.connectivityLineItems[0].planDetail &&
          leadDetails.connectivityLineItems[0].planDetail.speed) ||
        '';

      const [customerSelectedBwValue] = (customerSelectedBw && splittedBwValue(customerSelectedBw)) || '';

      const feasibilityReqBw = feasibilityResponse && feasibilityResponse.requestedBandwidth;

      return customerSelectedBwValue || feasibilityReqBw;
    };

    const selectedMedia = getSelectedMedia(getSiteSpecs());
    const savedMediaType = localStorage.getItem('media');

    let requestedBandwidth = getSelectedBw();

    if (selectedPlanSpeed) {
      const [bwValue] = splittedBwValue(selectedPlanSpeed);
      requestedBandwidth = bwValue;
    }

    const { primaryMediaList } = setMediaOptions(feasibilityResponse, requestedBandwidth);

    const getDropdownOptions = (value) => ({
      id: value,
      key: value,
      displayName: value
    });

    const getSelectedPrimaryMedia = () => {
      if (selectedPlanSpeed) {
        return primaryMediaList.length > 0 ? primaryMediaList[0] : {};
      }

      if (selectedMedia) {
        return getDropdownOptions(selectedMedia);
      } else {
        return getDropdownOptions(savedMediaType);
      }
    };

    const defaultPrimaryMedia = getSelectedPrimaryMedia();

    setPrimaryMediaOptions(isSiteManualFeasible || isSitePendingThirdParty ? [] : primaryMediaList);
    setSelectedPrimaryMedia(isSiteManualFeasible || isSitePendingThirdParty ? {} : { ...defaultPrimaryMedia, ...selectedPrimaryMedia });
  };

  useEffect(() => {
    // // set Media Type/ Options
    filteredMediaOptions();
  }, [leadDetails, pnqLeadData]);

  const updateDiConnectionData = (selectedAttributesData) => {
    //let getSelectedPla1n = {};
    let selectedAttributesDataObj = selectedAttributesData && selectedAttributesData.length && selectedAttributesData[0];
    let selectedAttributesArray = [];
    selectedAttributesDataObj &&
      Object.keys(selectedAttributesDataObj).length &&
      Object.keys(selectedAttributesDataObj).map((selectedAttributeKey) => {
        let selectedAttributesObj = {};
        selectedAttributesObj.linkType = 'PRIMARY';
        if (selectedAttributeKey && selectedAttributeKey === 'ipSubnet') {
          selectedAttributesDataObj[selectedAttributeKey] &&
            Object.keys(selectedAttributesDataObj[selectedAttributeKey]).length &&
            Object.keys(selectedAttributesDataObj[selectedAttributeKey]).map((subNetKeys) => {
              let selectedAttributesObj = {};
              selectedAttributesObj.name = subNetKeys;
              selectedAttributesObj.value = selectedAttributesDataObj[selectedAttributeKey][subNetKeys] && selectedAttributesDataObj[selectedAttributeKey][subNetKeys].key;
              selectedAttributesObj.commercial = ipAttributeType ? ipAttributeType : false;
              selectedAttributesObj.linkType = 'PRIMARY';
              selectedAttributesArray.push(selectedAttributesObj);
            });
        } else {
          selectedAttributesObj.name = selectedAttributeKey;
          selectedAttributesObj.value = selectedAttributesDataObj[selectedAttributeKey] && selectedAttributesDataObj[selectedAttributeKey].key;
          if (
            commercialAttribute &&
            commercialAttribute.configAttributesMap &&
            commercialAttribute.configAttributesMap[selectedAttributeKey] &&
            commercialAttribute.configAttributesMap[selectedAttributeKey].commercial
          ) {
            selectedAttributesObj.commercial = true;
          } else {
            selectedAttributesObj.commercial = false;
          }

          selectedAttributesArray.push(selectedAttributesObj);
        }
      });
    let getSelectedPlan = selectedPlan;
    if (getSelectedPlan) {
      if (getSelectedPlan.service) {
        getSelectedPlan.service = selectedserviceOption && selectedserviceOption.value;
      }
      if (getSelectedPlan && getSelectedPlan.specs && Object.keys(getSelectedPlan.specs).length > 0) {
        let getSpecs = setIpAttribueOnSiteSpecs(getSelectedPlan.specs, selectedAttributesArray);
        getSelectedPlan.specs = getSpecs;
      } else {
        getSelectedPlan.specs = selectedAttributesArray;
      }
      setselectedPlan({ ...getSelectedPlan });
    }
    setSelectedIpAttributes(selectedAttributesArray);
    setservicetype(selectedserviceOption && selectedserviceOption.value);
  };
  const closemorepopup = () => {
    setshowmorePopup(false);
    stopBackgroundScrolling();
  };
  const findArrayIndex = (array, key) => {
    let getIndex = array && array.length > 0 && array.findIndex((item) => item.name === key);
    return getIndex;
  };
  const setIpAttribueOnSiteSpecs = (siteSpecs, selectedIpAttributes) => {
    selectedIpAttributes &&
      selectedIpAttributes.map((selectedIpAttribute) => {
        let name = selectedIpAttribute && selectedIpAttribute.name;
        let getArrayIndex = findArrayIndex(siteSpecs, name);
        if (getArrayIndex !== -1) {
          siteSpecs[getArrayIndex] = selectedIpAttribute;
        } else {
          siteSpecs.push(selectedIpAttribute);
        }
      });
    return siteSpecs;
  };
  const checkLeadSatus = () => {
    let status = false;
    if (
      leadStatus &&
      (leadStatus.toUpperCase() === LEAD_STATUS.FEASIBILITY_PENDING ||
        leadStatus.toUpperCase() === LEAD_STATUS.PNQ_IN_PROGRESS ||
        leadStatus.toUpperCase() === LEAD_STATUS.PNQ_COMPLETED)
    ) {
      status = true;
    } else if (leadStatus == 'PRICING_APPROVAL_REQUEST_SENT' || leadStatus == 'PRICING_DOA_REJECTED' || leadStatus == 'PRICING_DOA_APPROVED' || leadStatus == 'LEAD_CANCELLED') {
      status = true;
    }
    return status;
  };

  const onSelect = (selectedPlanValue, index, selectedRouterObj) => {
    const selectedPlanData = JSON.parse(JSON.stringify(selectedPlanValue));
    const selectedPlanSpeed = (selectedPlan && selectedPlan.speed) || '';
    const currentPlanSpeed = (selectedPlanValue && selectedPlanValue.speed) || '';

    // update media type options based on selected bandwidth

    if (selectedPlanSpeed && currentPlanSpeed && selectedPlanSpeed !== currentPlanSpeed) {
      filteredMediaOptions(currentPlanSpeed);
    }

    if (selectedPlanData && selectedPlanData.routerSpecs && servicetype === 'MANAGED') {
      selectedPlanData.routerSpecs = [];
      selectedPlanData.routerSpecs =
        selectedRouter && selectedRouter[selectedPlanData.id]
          ? [selectedRouter[selectedPlanData.id]]
          : selectedRouterObj && selectedRouterObj[selectedPlanData.id]
          ? [selectedRouterObj[selectedPlanData.id]]
          : null;
    } else {
      selectedPlanData.routerSpecs = null;
    }
    if (pnqPayload && selectedRouter && selectedRouter[selectedPlanData.id]) {
      let lineItemSpecs = pnqPayload.lineItems[0].plan.specs;
      let siteSpecs = pnqPayload.lineItems[0].plan.site[0] && pnqPayload.lineItems[0].plan.site[0].siteSpecs;
      const lineItemIndex = lineItemSpecs && lineItemSpecs.length > 0 && lineItemSpecs.findIndex((lineItemSpec) => lineItemSpec.name === 'cpe');
      const siteSpaceIndex = siteSpecs && siteSpecs.length > 0 && siteSpecs.findIndex((siteSpec) => siteSpec.name === 'cpeSpecification');
      if (servicetype === 'MANAGED') {
        if (lineItemIndex !== -1) {
          lineItemSpecs[lineItemIndex].value = selectedRouter[selectedPlanData.id].make;
        } else {
          let cpeList = {};
          cpeList.name = 'cpe';
          cpeList.description = 'cpe';
          cpeList.value = selectedRouter[selectedPlanData.id].make;
          lineItemSpecs.push(cpeList);
        }
        if (siteSpaceIndex !== -1) {
          siteSpecs[siteSpaceIndex].value = selectedRouter[selectedPlanData.id].model;
        } else {
          let cpeSpecificationList = {};
          cpeSpecificationList.name = 'cpeSpecification';
          cpeSpecificationList.description = 'cpeSpecification';
          cpeSpecificationList.value = selectedRouter[selectedPlanData.id].model;
          siteSpecs.push(cpeSpecificationList);
        }
      } else {
        if (lineItemIndex !== -1) {
          lineItemSpecs[lineItemIndex].value = 'None';
        } else {
          let cpeList = {};
          cpeList.name = 'cpe';
          cpeList.description = 'cpe';
          cpeList.value = 'None';
          lineItemSpecs.push(cpeList);
        }
        if (siteSpaceIndex !== -1) {
          siteSpecs[siteSpaceIndex].value = null;
        } else {
          let cpeSpecificationList = {};
          cpeSpecificationList.name = 'cpeSpecification';
          cpeSpecificationList.description = 'cpeSpecification';
          cpeSpecificationList.value = null;
          siteSpecs.push(cpeSpecificationList);
        }
      }
      pnqPayload.lineItems[0].plan.specs = lineItemSpecs;
      pnqPayload.lineItems[0].plan.site[0].specs =
        getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN ? siteSpecs : setIpAttribueOnSiteSpecs(siteSpecs, selectedIpAttributes);
      pnqPayload.lineItems[0].subProductName = servicetype;
      if (selectedPlanData && selectedPlanData.speed) {
        pnqPayload.lineItems[0].plan.bandwidth = selectedPlanData.speed;
      }
      if (selectedPlanData && selectedPlanData.price) {
        pnqPayload.lineItems[0].plan.price.oneTimeCharge = selectedPlanData.price.otc;
        pnqPayload.lineItems[0].plan.price.rental = selectedPlanData.price.amount;
      }

      setpnqPayload(pnqPayload);
    }
    selectedPlanData.service = servicetype;
    selectedPlanData.specs = getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN ? getPlanSpecs(selectedPlanData) : selectedIpAttributes;
    setselectedPlan({ ...selectedPlanData });
    faOnDedicatedSelectPlanClick();
    let activePlan = {
      activeId: selectedPlanData.id,
      planSpeed: selectedPlanData.speed
    };
    setactiveId(activePlan);
    updateCommercialAttrs(plans, activePlan, false);
  };

  const choosePlan = (plan, index) => {
    if (
      getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN &&
      currentPlanIpAttribute &&
      currentPlanIpAttribute.attributeChanged &&
      selectedPlan &&
      plan.speed !== selectedPlan.speed
    ) {
      setChangePlan({
        plan,
        index
      });
      showChangePlanModal();
    } else {
      //onSelect(plan, index);
      showSelectContractPeriod(plan, index);
    }
  };

  const confirmChangePlan = () => {
    if (changePlan) {
      changeIpAttributeType({
        ipAttributeType: false,
        speed: 0,
        attributeChanged: false
      });
      closeChangePlanModal();
      onSelect(changePlan.plan, changePlan.index);
      setChangePlan(null);
    }
  };

  const showChangePlanModal = () => {
    setShowChangePlan(true);
  };

  const closeChangePlanModal = () => {
    setShowChangePlan(false);
  };

  const getPlanSpecs = (newPlan) => {
    if (selectedPlan && selectedPlan.speed === newPlan.speed) {
      if (selectedPlan.specs) return selectedPlan.specs;
    }
    const bandwidths = getFromSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH);
    const leadStatus = checkLeadSatus();
    const defaultValue = getDefaultValue(commercialAttribute, bandwidths, newPlan, leadStatus, 'PRIMARY');
    const model = prepareSpecModel(defaultValue, {});
    const ipAttributeData = { ...currentPlanIpAttribute };
    ipAttributeData.attributeChanged = false;
    setCurrentPlanIpAttribute(ipAttributeData);
    return model;
  };

  const changeIpAttributeType = (data) => {
    setIpAttributeType(data.ipAttributeType);
    setCurrentPlanIpAttribute(data);
  };

  const getPlanServiceFromSpecs = (specs) => {
    const spec = specs.find((row) => row.name === 'manageability');
    return spec ? spec.value : 'MANAGED';
  };

  const setCustomPlan = (data) => {
    setSelectedIpAttributes(data);
    const plan = { ...selectedPlan };
    const dualLmAttributesIndex = data && data.length > 0 && data.findIndex((item) => item.value === 'Dual LM');
    if (data && data.length > 0) {
      for (let siteIndex = 0; siteIndex < data.length; siteIndex++) {
        if (dualLmAttributesIndex !== -1 && data[siteIndex].linkType === 'SECONDARY' && (data[siteIndex].name === 'lastMile' || data[siteIndex].name === 'redundancy')) {
          data.splice(siteIndex, 1);
        }
      }
    }
    plan.specs = data;
    plan.service = getPlanServiceFromSpecs(data);
    setselectedPlan({ ...plan });
  };
  const showSelectContractPeriod = (plan, index) => {
    setshowPopup(true);
    faOnDedicatedContractPeriodLoad();
    stopBackgroundScrolling(true);
    setPlanIndex({ plan, index });
  };
  const popupCloseHandler = (type = null) => {
    setshowPopup(false);
    stopBackgroundScrolling();
  };

  const onServiceChange = (value) => {
    setselectedserviceOption(value);
  };
  const onContractChange = (value) => {
    setselectedcontractOption(value);
    setcontractPeriod(value.displayName);
  };
  const okClickHandler = () => {
    faOnDedicatedContractPeriodOKClick(contractPeriod && contractPeriod.value);
    setshowPopup(false);
    setactiveStep('summary');
    stopBackgroundScrolling();
    onSelect(planObject.plan, planObject.index);
  };
  const afterSlideCallback = (prev, curr) => {
    let current = Math.round(prev);
    setcurrentSpeedIndex(current);
    setplansArray(plans.slice(current, current + 4));
    let leadData = pnqLeadData && pnqLeadData.length > 0 && pnqLeadData[0];
    if (leadData && leadData.lineItems && leadData.lineItems.length > 0 && paramsValue && paramsValue.user === 'KAM') {
      setRouterSpecs(plans.slice(current, current + 4), leadData);
    } else {
      setRouterSpecs(plans.slice(current, current + 4));
    }
  };

  const renderDots = () =>
    speedArray.length &&
    speedArray.map((i, index) => (
      <div className="sliderRange" key={index}>
        <div className="range_value">
          {i} <span>Mbps</span>
        </div>
      </div>
    ));

  // const value = { min: 2000, max: 2017 };
  const rendermedia = (plan) => {
    let mediaType = plan?.media?.id ?? localStorage.getItem('media');

    if ((activeId && activeId.planSpeed) === plan.speed) {
      const isSiteManualFeasible = feasibilityData && feasibilityData.feasibilityStatus === 'MANUAL_INTERVENTION_REQUIRED';
      const isSitePendingThirdParty = feasibilityData && feasibilityData.feasibilityStatus === 'PENDING_FOR_THIRD_PARTY';

      if (isSiteManualFeasible || isSitePendingThirdParty) {
        return mediaType;
      }

      return (selectedPrimaryMedia && Object.keys(selectedPrimaryMedia).length > 0 && selectedPrimaryMedia.key) || mediaType;
    }

    if (plan && plan.speed.split(' ')[1] == 'Gbps') {
      if (+plan.speed.split(' ')[0] * 1024 <= maxBandwidth) {
        return mediaType;
      }
    } else {
      if (+(plan && plan.speed.split(' ')[0]) <= maxBandwidth) {
        return mediaType;
      }
    }
    return '-';
  };

  const leadConfStatus = checkLeadSatus();

  const handlePlanConfigration = () => {
    setPlanConfigrationOpen(true);
    let type = 'edit';
    if (leadConfStatus) {
      type = 'view';
    }
    if (paramsValue && paramsValue.user == 'KAM') {
      faOnDedicatedKamPlanConfiguration({ type });
    } else {
      faOnDedicatedPlanConfiguration({ type });
    }
  };
  const checkStandardPlanStatus = () => {
    let standardPlanStatus = false;
    let findStandardPlanIndex = plansArray && plansArray.length > 0 && plansArray.findIndex((planValues) => planValues.standardRate === true);
    if (findStandardPlanIndex !== -1 && plansArray && plansArray.length > 0) {
      standardPlanStatus = true;
    }
    return standardPlanStatus;
  };
  const checkCapexValue = (plan) => {
    let status = false;
    let getMediaType = rendermedia(plan);
    //|| getMediaType.toLowerCase === CAPEX_MEDIA_TYPE.thirdParty.toLowerCase()
    if (getMediaType && getMediaType.length > 1 && leadStatus === LEAD_STATUS.PNQ_COMPLETED && getMediaType.toLowerCase() === CAPEX_MEDIA_TYPE.offnet.toLowerCase()) {
      status = true;
    }
    return status;
  };
  useEffect(() => {
    let sendQuotation = selectedPlan;
    if (sendQuotation && Object.keys(sendQuotation).length > 0) {
      sendQuotation.selectedContractPeriod = selectedcontractOption && selectedcontractOption.value ? selectedcontractOption.value : 1;
      setInSessionStorage(MODULE_ID, 'sendQuotation', sendQuotation);
    }
  }, [selectedPlan, selectedcontractOption]);
  const renderPlans = () => {
    let selectedPlanIndex = getSelectedPlanIndex();
    let getPlansArray = checkSelectedPlan() && plansArray.length > 0 ? [plansArray[selectedPlanIndex >= plansArray.length ? 0 : selectedPlanIndex]] : plansArray;
    return (
      <BaseCarousel className={`plan-list ${paramsValue && paramsValue.user !== 'KAM' && leadStatus === LEAD_STATUS.PNQ_COMPLETED ? 'leadDisabled' : ''}`}>
        {getPlansArray &&
          getPlansArray.length &&
          getPlansArray.map((plan, index) => (
            // <div key={index} className={activeId && plan && activeId.activeId == plan.id ? "plan_items selected" : "plan_items"}>
            <div key={index} className={activeId && plan && activeId.planSpeed == plan.speed ? 'plan_items selected' : 'plan_items'}>
              <div className="items-card">
                <div className="info_strip">{checkCapexValue(plan) ? '*CapEx charges may apply' : ''} &nbsp;</div>
                <div className="card-content">
                  <div className="plan-head">
                    <div className="left">
                      <div className="title">Bandwidth</div>
                      <div className="get-speed">{plan && plan.speed}</div>
                    </div>
                  </div>
                  <div className="plan-info">
                    <div className="info">
                      <div className="info_icon">
                        <img src={wireless} alt="Wireless" />
                      </div>
                      <div className="type">{rendermedia(plan) || '-'}</div>
                      <small>Media Type</small>
                    </div>
                    <div className="info">
                      <div className="info_icon">
                        <img src={services} alt="Services" />
                      </div>
                      <div className="type caps-letter-only">{selectedserviceOption && selectedserviceOption.displayName.toLowerCase()}</div>
                      <small>Service Type</small>
                    </div>
                    <div className="info">
                      <div className="info_icon">
                        <img src={ipAttribute} alt="IP" />
                      </div>
                      {/* <div className="type">{ipAttributeType ? ATTRIBUTE_TEXT.NON_STANDARD : ATTRIBUTE_TEXT.STANDARD}</div> */}
                      <div className="type">
                        {currentPlanIpAttribute && plan
                          ? currentPlanIpAttribute.speed === plan.speed && currentPlanIpAttribute.ipAttributeType
                            ? ATTRIBUTE_TEXT.NON_STANDARD
                            : ATTRIBUTE_TEXT.STANDARD
                          : ATTRIBUTE_TEXT.STANDARD}
                      </div>
                      <small>IP Attributes</small>
                    </div>
                  </div>
                  {servicetype && servicetype === 'MANAGED' && selectedRouter && selectedRouter[plan.id] ? (
                    <div className="plan-info">
                      <div className="info">
                        <div className="type capitalize">{selectedRouter && selectedRouter[plan.id] && selectedRouter[plan.id].make}</div>
                        <small>Router Type</small>

                        <div className="changeRouter" onClick={() => changeRouter(plan.id)}>
                          Change Router
                        </div>
                      </div>
                      <div className="info">
                        <div className="type uppercase">{selectedRouter && selectedRouter[plan.id] && selectedRouter[plan.id].model}</div>
                        <small>Router Specification</small>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="card-footer">
                  <div className="discription">
                    <div className="discript-item">
                      <div className="info">
                        {
                          // (activeId && activeId.activeId) == plan.id ?
                          (activeId && activeId.planSpeed) == plan.speed ? (
                            <React.Fragment>
                              {selectedcontractOption && selectedcontractOption.value && selectedcontractOption.value === 1
                                ? selectedcontractOption.value + ' Year'
                                : selectedcontractOption && selectedcontractOption.value && selectedcontractOption.value + ' Years'}
                            </React.Fragment>
                          ) : (
                            '1 Year'
                          )
                        }
                      </div>
                      <div className="title">Contract Period</div>
                      <div className="changeRouter" onClick={() => showSelectContractPeriod(plan, index)}>
                        Change Contract Period
                      </div>
                    </div>
                    <div className="discript-item">
                      <div className="info">
                        &#8377;
                        {plan && plan.price && activeId && activeId.planSpeed == plan.speed && selectedPlan && selectedPlan.price && selectedPlan.price.otc
                          ? selectedPlan.price.amount === 0
                            ? 'N/A'
                            : numberWithCommas(selectedPlan.price.otc)
                          : plan.price.amount === 0
                          ? 'N/A'
                          : numberWithCommas(plan.price.otc)}
                      </div>
                      <div className="title">Installation Fee</div>
                      <small>(one time)</small>
                    </div>
                    <div className="discript-item">
                      <div className="info">
                        &#8377;
                        {plan && plan.price && activeId && activeId.planSpeed == plan.speed && selectedPlan && selectedPlan.price && selectedPlan.price.amount
                          ? selectedPlan.price.amount === 0
                            ? 'N/A'
                            : numberWithCommas(selectedPlan.price.amount)
                          : plan.price.amount === 0
                          ? 'N/A'
                          : numberWithCommas(plan.price.amount)}
                        <small>/year</small>
                      </div>
                      <div className="title">Annual Charges</div>
                      <small>(exclu. of GST)</small>
                    </div>
                  </div>
                </div>
                <div className="footer_action_btn">
                  <Button
                    onClick={
                      () => choosePlan(plan, index)
                      // {
                      // if(!activeId || activeId.planSpeed !== plan.speed)
                      //   choosePlan(plan, index)
                      // }
                    }
                    variant={(activeId && activeId.planSpeed) == plan.speed ? 'activebtn' : 'outlinebtn'}
                  >
                    {(activeId && activeId.planSpeed) == plan.speed ? 'Selected Plan' : 'Select Plan With Contract Period'}
                  </Button>
                </div>
              </div>
            </div>
          ))}
      </BaseCarousel>
    );
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="container round-loader">
          <MainLoader />
          <p className="loader-heading">
            <span className="color-red">Loading…</span>
            <br />
            Please Wait.
          </p>
        </div>
      ) : (
        <div className={`main-controller ${disable ? 'leadDisabled' : ''}`}>
          <section className="thanks-section plan-page">
            <div className="wrapper_col">
              <div className="col">
                <div className="accordion-card">
                  <div className={`accordion-content ${paramsValue && paramsValue.user !== 'KAM' && leadStatus === LEAD_STATUS.PNQ_COMPLETED ? 'leadDisabled' : ''}`}>
                    <div className="choose-type">
                      <div className="bandwidth">
                        <div className="bandwidthBox">
                          {/* <h5>Choose required bandwidth <span>(in Mbps)</span></h5> */}
                          <h5>Bandwidth Range</h5>
                          {checkLeadSatus() && !showAllPlan && <p onClick={() => setShowAllPlanList(true)}>View All</p>}
                          {checkLeadSatus() && showAllPlan && <p onClick={() => setShowAllPlanList(false)}>Selected Plan</p>}
                        </div>
                        <div className={`slidecontainer ${checkLeadSatus() && !showAllPlan && 'arrow-disabled'}`}>
                          <Slider ref={childRef} {...settings}>
                            {renderDots()}
                          </Slider>
                        </div>
                      </div>
                      <div className="user_usage">&nbsp; </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="accordion-card configure_info">
                  <div className="accordion-content">
                    <div className="configration_action">
                      <h6>Plan Configuration</h6>
                      {commercialAttribute && Object.keys(commercialAttribute).length > 0 && (
                        <Button disabled={getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN && selectedPlan === null} onClick={handlePlanConfigration}>
                          {leadConfStatus ? 'View Configuration' : 'Edit Configuration'}
                        </Button>
                      )}
                      {plans && plans.length > 0 && commercialAttribute && Object.keys(commercialAttribute).length > 0
                        ? getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN
                          ? selectedPlan &&
                            Object.keys(selectedPlan).length > 0 &&
                            getFromSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH) && (
                              <PlanConfigurationForMPLS
                                open={planConfigrationOpen}
                                close={setPlanConfigrationOpen}
                                commercialAttributes={commercialAttribute}
                                updateDiConnectionData={setCustomPlan}
                                changeIpAttributeType={changeIpAttributeType}
                                setservicetype={setservicetype}
                                ipAttributeType={ipAttributeType}
                                checkLeadSatus={checkLeadSatus}
                                selectedPlan={selectedPlan}
                                leadDetails={leadDetails}
                                dualLastMile={dualLastMile}
                                paramsValue={paramsValue}
                                setServiceOption={onServiceChange}
                                selectedPrimaryMedia={selectedPrimaryMedia}
                                setSelectedPrimaryMedia={setSelectedPrimaryMedia}
                                primaryMediaOptions={primaryMediaOptions}
                                feasibilityData={feasibilityData}
                              />
                            )
                          : getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.DEDICATED_INTERNET && (
                              <PlanConfigrationModal
                                selectedPlan={selectedPlan}
                                planConfigrationOpen={planConfigrationOpen}
                                setPlanConfigrationOpen={setPlanConfigrationOpen}
                                serviceOptions={serviceOptions}
                                selectedserviceOption={selectedserviceOption}
                                onServiceChange={onServiceChange}
                                servicetype={servicetype}
                                commercialAttribute={commercialAttribute}
                                planSpecs={selectedIpAttributes}
                                updateDiConnectionData={updateDiConnectionData}
                                setIpAttributeType={setIpAttributeType}
                                ipAttributeType={ipAttributeType}
                                checkLeadSatus={checkLeadSatus}
                                setPlanSlider={setPlanSlider}
                                paramsValue={paramsValue}
                                selectedPrimaryMedia={selectedPrimaryMedia}
                                setSelectedPrimaryMedia={setSelectedPrimaryMedia}
                                primaryMediaOptions={primaryMediaOptions}
                                feasibilityData={feasibilityData}
                              />
                            )
                        : null}
                    </div>
                    <div className="config_info caps-letter-only">
                      Service type: <strong>{selectedserviceOption && selectedserviceOption.displayName.toLowerCase()}</strong>
                    </div>
                    <div className="config_info">
                      IP Attributes: <strong>{ipAttributeType ? ATTRIBUTE_TEXT.NON_STANDARD : ATTRIBUTE_TEXT.STANDARD}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="plan-content">
              <div className="agreement_info">
                {checkLeadSatus() && leadStatus !== LEAD_STATUS.PNQ_COMPLETED && paramsValue && paramsValue.user !== 'KAM' ? (
                  <div className="info_content updates-alert1">
                    <div className="icon">
                      <img src={helplineIcon} alt="" />
                    </div>
                    {leadStatus === LEAD_STATUS.FEASIBILITY_PENDING && leadDetails && !leadDetails.needAssistance ? LEAD_STATUS_MSG.FEASIBILITY_PENDING : LEAD_STATUS_MSG.KAM_MG}
                  </div>
                ) : (
                  // showManualFeasibilityMsg ?
                  //     <div className="updates-alert1 info_content">
                  //       <div className="icon"><img src={ribbonBadge} alt="" /></div>
                  //       {LEAD_STATUS_MSG.MANUAL_INTERVENTION_REQUIRED}
                  //     </div>
                  //     :
                  ''
                )}
                {checkLeadSatus() && leadStatus !== LEAD_STATUS.PNQ_COMPLETED && paramsValue && paramsValue.user === 'KAM' ? (
                  <div className="info_content updates-alert1">
                    <div className="icon">
                      <img src={helplineIcon} alt="" />
                    </div>
                    Company agreed rates are displayed in the plans below.
                  </div>
                ) : (
                  paramsValue.user === 'KAM' && (
                    <div className="info_content updates-alert1">
                      <div className="icon">
                        <img src={ribbonBadge} alt="" />
                      </div>
                      {checkStandardPlanStatus()
                        ? 'Please select a plan and contract period to proceed.'
                        : 'Company agreed rates are displayed in the plans below. Please select a plan and contract period to proceed.'}
                    </div>
                  )
                )}
                {leadStatus === LEAD_STATUS.PNQ_COMPLETED && leadDetails.doaStatus !== 'REJECTED' && paramsValue && paramsValue.user !== 'KAM' && (
                  <div className="updates-alert1 success-msg info_content">
                    <div className="icon">
                      <img src={helplineIcon} alt="" />
                    </div>
                    {LEAD_STATUS_MSG.PNQ_COMPLETED_MSG_CUSTOMER}
                  </div>
                )}
                {leadStatus === LEAD_STATUS.IN_PROGRESS && (
                  <div className="info_content">
                    <div className="icon">
                      <img src={ribbonBadge} alt="" />
                    </div>
                    {checkStandardPlanStatus()
                      ? 'Please select a plan and contract period to proceed.'
                      : 'Company agreed rates are displayed in the plans below. Please select a plan and contract period to proceed.'}
                  </div>
                )}
              </div>
              {paramsValue?.user !== 'KAM' && (
                <div className="rate_card_list">
                  <Select
                    placeholder=""
                    label="Rate Card Id"
                    value={selectedRateCardId}
                    onChange={(selectedRateCard) => setSelectedRateCardId(selectedRateCard)}
                    options={rateCardIdList}
                    required
                  />
                </div>
              )}
              {plansArray && plansArray.length > 0 && renderPlans()}
              {kamDetails && Object.keys(kamDetails).length > 0 && (
                <NeedAssistant
                  selectedPlan={selectedPlan}
                  kamDetails={kamDetails}
                  isdedicatedJourney={true}
                  fetchLead={fetchLead}
                  contractPeriod={selectedcontractOption}
                  leadStatus={leadStatus}
                  leadDetails={leadDetails}
                  setAPIFetechingState={setAPIFetechingState}
                  selectedRouter={selectedRouter}
                  checkLeadSatus={checkLeadSatus}
                  ipAttributeType={ipAttributeType}
                  selectedIpAttributes={selectedIpAttributes}
                  selectedPrimaryMedia={selectedPrimaryMedia}
                  itemCode={itemCode}
                  selectedRateCardId={selectedRateCardId}
                />
              )}
              {paramsValue && paramsValue.user !== 'KAM' && (
                <StripComponent
                  selectedPlan={selectedPlan}
                  contractPeriod={selectedcontractOption}
                  servicetype={selectedserviceOption.displayName}
                  setisLoading={setisLoading}
                  leadStatus={leadStatus}
                  leadDetails={leadDetails}
                  fetchLead={fetchLead}
                  selectedRouter={selectedRouter}
                  submitLead={submitLead}
                  ipAttributeType={ipAttributeType}
                  selectedHardwareType={selectedHardwareType}
                  selectedIpAttributes={selectedIpAttributes}
                  feasibilityData={feasibilityData}
                  selectedPrimaryMedia={selectedPrimaryMedia}
                  itemCode={itemCode}
                  selectedRateCardId={selectedRateCardId}
                />
              )}
            </div>
            {paramsValue && paramsValue.user === 'KAM' && remarks && (
              <div className="message_customer">
                <div className="accordion-card">
                  <div className="accordion-content">
                    <CustomerMessageCard remarks={remarks} />
                  </div>
                </div>
              </div>
            )}
            {paramsValue && paramsValue.user === 'KAM' && pnqPayload && selectedPlan && selectedPlan.price && (
              <OrderSummary
                selectedIpAttributes={selectedIpAttributes}
                plansArray={plansArray}
                selectedRouter={selectedRouter}
                getKamLeadData={getKamLeadData}
                paramsValue={paramsValue}
                kamPlan={kamPlan}
                selectedPlan={selectedPlan}
                selectedContractPeriod={selectedcontractOption}
                doaStatus={doaStatus}
                doaId={doaId}
                leadStatus={leadStatus}
                pnqPayload={pnqPayload}
                setAPIFetechingState={setAPIFetechingState}
                ipAttributeType={ipAttributeType}
                selectedHardwareType={selectedHardwareType}
                setselectedcontractOption={setselectedcontractOption}
                feasibilityData={feasibilityData}
                selectedPrimaryMedia={selectedPrimaryMedia}
                itemCode={itemCode}
              />
            )}
            {showRouterPopup && (
              <RouterPopup
                closeRouterPopup={closeRouterPopup}
                routerSpecsMake={routerSpecsMake && routerSpecsMake.length > 0 ? routerSpecsMake : routerSpecsMake[routerIndex]}
                routerSpecsModel={routerSpecsMake && routerSpecsMake.length > 0 ? routerSpecsModel : routerSpecsModel[routerIndex]}
                routerIndex={routerIndex}
                changeetRouterValue={changeetRouterValue}
                selectedRouter={selectedRouter}
                plansArray={plansArray}
                setSelectedRouter={setSelectedRouter}
                selectedHardwareType={selectedHardwareType}
                setHardwareType={setHardwareType}
                commercialAttribute={commercialAttribute}
                setRouterSpecsModel={setRouterSpecsModel}
                setRouterSpecsMake={setRouterSpecsMake}
                setPlanSlider={setPlanSlider}
                planSpecificRouter={planSpecificRouter}
                itemCode={itemCode}
                setItemCode={setItemCode}
              />
            )}
            {showPopup && (
              <ContractSelectModal
                showPopup={showPopup}
                contractOptions={contractOptions}
                selectedcontractOption={selectedcontractOption}
                onContractChange={onContractChange}
                popupCloseHandler={popupCloseHandler}
                okClickHandler={okClickHandler}
                selectedPlan={
                  planObject && planObject.plan && planObject.plan.price ? planObject.plan : changePlan && changePlan.plan && changePlan.plan.price ? changePlan.plan : selectedPlan
                }
                // ipAttributeType={ipAttributeType}
                // changeIpAttributeType={changeIpAttributeType}
              />
            )}
            {showChangePlan && (
              <ChangePlanModal
                showPopup={showChangePlan}
                selectedPlan={selectedPlan}
                changePlan={changePlan}
                ipAttributeType={ipAttributeType}
                changeIpAttributeType={changeIpAttributeType}
                closeChangePlanModal={closeChangePlanModal}
                confirmChangePlan={confirmChangePlan}
              />
            )}
            <ServicesPopup showmorePopup={showmorePopup} closemorepopup={closemorepopup} />
          </section>
        </div>
      )}
    </React.Fragment>
  );
};
export default DedicatedPlanPage;
